(function () {
  var sections = document.querySelectorAll('.rotating-text-banner');

  sections.forEach(function (section) {
    var slides = section.querySelectorAll('.rotating-text-banner__slide');
    if (slides.length <= 1) return;

    var speed = parseFloat(getComputedStyle(section).getPropertyValue('--rotation-speed')) || 3;
    var currentIndex = 0;

    setInterval(function () {
      var currentSlide = slides[currentIndex];
      var nextIndex = (currentIndex + 1) % slides.length;
      var nextSlide = slides[nextIndex];

      // Move current slide up and out
      currentSlide.classList.remove('is-active');
      currentSlide.classList.add('is-exiting');

      // Place next slide below (no transition), then animate in
      nextSlide.style.transition = 'none';
      nextSlide.style.transform = 'translateY(100%)';
      nextSlide.style.opacity = '0';

      // Force reflow so the "no transition" state takes effect
      void nextSlide.offsetHeight;

      // Now animate the next slide up into place
      nextSlide.style.transition = '';
      nextSlide.style.transform = '';
      nextSlide.style.opacity = '';
      nextSlide.classList.add('is-active');

      // Clean up exiting slide
      setTimeout(function () {
        currentSlide.classList.remove('is-exiting');
      }, 500);

      currentIndex = nextIndex;
    }, speed * 1000);
  });
})();
